import { Icon } from '../../icons';

export default function SearchBar({ value, onChange, placeholder = "Search…", className = "" }) {
  return (
    <div className={`flex items-center gap-2 bg-slate-50 dark:bg-slate-800 border border-border dark:border-slate-700 rounded-xl px-3 py-2 ${className}`}>
      <Icon name="search" size={14} className="text-muted flex-shrink-0" />
      <input type="search" autoComplete="off" autoCorrect="off" spellCheck="false" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="bg-transparent border-0 outline-none text-sm text-ink dark:text-white flex-1 min-w-0 placeholder:text-slate-300 dark:placeholder-slate-500" />
      {value && <button type="button" onClick={() => onChange("")} className="text-muted hover:text-ink dark:hover:text-slate-100 bg-transparent border-0 cursor-pointer flex-shrink-0 flex items-center justify-center"><Icon name="x" size={12} /></button>}
    </div>
  );
}
